import { CancelButton, SaveButton } from '@core/components/Buttons';
import { FormDialogContent, SimpleDialog } from "@core/components/Dialog";
import { cancelarAlert } from 'app/services/alerts';
import { FormikProvider, useFormik } from 'formik';
import React, { useContext } from 'react';
import { VendaContext } from '../../VendaContext';
import { VendaModais } from '../modal/VendaModais';
import VendaBuscaAvancadaForm from './VendaBuscaAvancadaForm';


const VendaBuscaAvancadaModal = ({ fetchVendas }) => {

  const [modal, setModal] = useContext(VendaContext).modal;
  const [filtroAvancado, setFiltroAvancado] = useContext(VendaContext).filtroAvancado;
  const [search] = useContext(VendaContext).search;
  const [size] = useContext(VendaContext).size;
  const [sort] = useContext(VendaContext).sort;

  const handleCancelar = ( ) => {
    if (formik.dirty){
      cancelarAlert({
        confirmar: () => {
          formik.resetForm(formik.initialValues)
          setModal('')
        }
      })
    } else {
      setModal('');
    }
  }

  const handleSubmit = (values) => {
    const filtroAvancado = {
      ...values,
      clienteId: values?.cliente?.id,
      transportadoraId: values?.transportadora?.id,
      vendedorId: values?.vendedor?.id
    }

    delete filtroAvancado.cliente;
    delete filtroAvancado.transportadora;
    delete filtroAvancado.vendedor;

    setFiltroAvancado(filtroAvancado);
    fetchVendas({ q: search, filtroAvancado, size, sort });
    setModal('');
  }

  const formik = useFormik({
    initialValues: {
      identificador: filtroAvancado.identificador,
      data: filtroAvancado.data,
      cliente: filtroAvancado.cliente,
      situacao: filtroAvancado.situacao,
      transportadora: filtroAvancado.transportadora,
      vendedor: filtroAvancado.vendedor,
    },
    onSubmit: handleSubmit
  })
 
  return (
    <SimpleDialog open={modal === VendaModais.buscaAvancada} onClose={handleCancelar}>
      <FormikProvider value={formik}>
        <FormDialogContent
          onSubmit={formik.handleSubmit}
          header={{
            title: 'Busca Avançada',
            toolbar: (
              <>
                <CancelButton title="cancelar" type="button" onClick={handleCancelar}>
                  Cancelar
                </CancelButton>
                <SaveButton color="buttonSave" type="submit">
                  Aplicar
                </SaveButton>
              </>
            ),
          }}
          content={<VendaBuscaAvancadaForm />}
          contentStyle={{ padding: 0 }}
        />
      </FormikProvider>
    </SimpleDialog>
  )
}

export default VendaBuscaAvancadaModal;